module.exports = __webpack_public_path__ + "static/media/noun-wave-green.66556ed6.svg";